import '@coverflex-tech/hypernova/lib/colors/employee.css';
import { AppInitProvider } from '@/common/contexts/AppInitProvider';
import { AuthProvider } from '@/common/contexts/authentication/AuthProvider';
import { ReactQueryProvider } from '@/common/contexts/react-query/ReactQueryProvider';
import { ToastProvider } from '@/common/contexts/toast/ToastProvider';
import '@/common/i18n';
import { ScrollToTop } from '@/common/utils/ScrollToTop';
import { ErrorBoundary } from '@/web/components/ErrorBoundary/ErrorBoundary';
import { ThemeProvider } from '@/web/contexts/ThemeProvider/ThemeProvider';
import CartProvider from '@/web/contexts/cart/CartProvider';
import { Slot } from 'expo-router';
import '@/web/index.css';

if (process.env.EXPO_PUBLIC_MOCK === 'true') {
  require('@/common/mocks/mocks.sw');
}

export default function RootLayout() {
  return (
    <ThemeProvider>
      <ErrorBoundary>
        <ToastProvider>
          <ReactQueryProvider>
            <AuthProvider>
              <CartProvider>
                <AppInitProvider>
                  <ScrollToTop />
                  <Slot />
                </AppInitProvider>
              </CartProvider>
            </AuthProvider>
          </ReactQueryProvider>
        </ToastProvider>
      </ErrorBoundary>
    </ThemeProvider>
  );
}
